module.exports = __webpack_public_path__ + "img/profile.50335154.svg";